export default __webpack_public_path__ + "static/media/NoDataAvail.8076ab1f.svg";